import React, { Component } from 'react';
import config from 'react-global-configuration';
import RequestApi from '../Miscelania/RequestApi';

import Topo from '../Layout/Topo';
import Overlay from '../Miscelania/Overlay';

import InputMask from 'react-input-mask';

// Importação da tabela
import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table';
import getLocale from '../../i18n/getLocale';


class SearchAuxiliaryReport extends Component {
  constructor(props) {
    super(props);

    this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'open',        
      },
      redirect_url: false,
      loaded: 0,
      data: [],
      data_modal: {},
      date_start: null,
      date_finish: null,
    };
    
    //Handlers
    this.handleAlert = this.handleAlert.bind(this);
    this.handleLoaded = this.handleLoaded.bind(this);
    this.handleMessage = this.handleMessage.bind(this);

    this.ActionsButtons = this.ActionsButtons.bind(this);
    this.loadData = this.loadData.bind(this);
    this.loadModal = this.loadModal.bind(this);
    this.showModal = this.showModal.bind(this);
    this.closeModal = this.closeModal.bind(this);
    this.searchReports = this.searchReports.bind(this);

    this.locale = getLocale();
  }

  // Handlers
  handleChange (name, event) {
    var change = {};
    change[name] = event.target.value;
    this.setState(change);
  }
  
  handleAlert(message, type, status, mode) {
    if(mode === 'reset') {
      this.setState({overlay: {message: '', type: '', status: 'closed'}});
    } else {
      this.setState({overlay: {message: message, type: type, status: status}});
    }
  }


  handleLoaded(state) {
    if(this.state.loaded !== 2) {
      this.setState({loaded: state});      
    }
  }

  handleMessage () {
    var message = localStorage.getItem("verify_message");
    if (message !== null && typeof message !== 'undefined') {
      message = JSON.parse(message);
      var self = this;
      self.setState({overlay: {message: message.alert_message, type: message.alert_type, status: 'open'}});
      localStorage.removeItem("verify_message");
    }
  }
  
  componentDidMount () {
    this.refs.request_api.header();
  }

  componentDidUpdate(prevProps, prevState) {
    if(this.state.loaded === 1 && prevState.loaded === 0) {
      this.setState({loaded: 2}, this.loadData());
    }
  }
  loadData () {
    var self = this;
    var header = this.refs.request_api.header('application/json');
    self.setState({overlay: {message: '', type: '', status: 'closed'}});
  }

  loadModal (value, event) {
    var self = this;
    var id = (value);
    self.setState({overlay: {message: '', type: '', status: 'open'}});
    var header = this.refs.request_api.header('application/json');
    Promise.resolve(header).then(function(value) {
      var url = config.get('api') + '/relatorio-de-fadiga/'+ id;
      fetch(url, { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'url');
        if (responseJson.status === 'success') {
          self.setState({data_report_fatigues:responseJson.data});
          self.showModal();
        }
      }).then(() => {
        self.setState({overlay: {message: '', type: '', status: 'closed'}});
      }); /* Overlay */
    });
  }

  showModal (value, event) {
    this.setState({ modal: true});
  }
  closeModal (event) {
    this.setState({ modal: false});
  }

  searchReports(event) {
    event.preventDefault();
    this.handleAlert('', '', 'open');
    var datasave = {
      date_start: this.state.date_start,
      date_finish: this.state.date_finish,
    };

    var header = this.refs.request_api.header('application/json');
    var self = this;
    Promise.resolve(header).then(function(value) {
      fetch(config.get('api') + '/reporte/ferramenta/auxiliar/pesquisar', { method: 'POST', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'alert');
        if (responseJson.status === 'success') {
          self.setState({data: responseJson.data});
          self.setState({overlay: {message: '', type: '', status: 'closed'}});
        } else {
          self.setState({overlay: {message: responseJson.message, type: responseJson.status, status: 'open'}});
        }
      }).catch((error) => {
        console.error(error);
      });
    });
  }

  ActionsButtons (cell, row) {    
    var botao = (
      <div className="btn-group">
        <button onClick={this.loadModal.bind(this, cell)} className='btn btn-sm btn-info' alt={this.locale.general.informacoes} title={this.locale.general.informacoes}><i className="fa fa-fw fa-eye"></i></button>
      </div>
    );

    return botao;
  }

  render() {
    var self = this;
    return (
<div>
  
  <RequestApi ref={'request_api'} handleLoaded={this.handleLoaded} />
  <Overlay overlay={this.state.overlay} handleAlert={this.handleAlert} />
  <div className="container-liquid">
    <div className="conteudo">
      <h3 className="page-title">{this.locale.RelatoriosAuxiliaresFadiga.ProcurarRelatorioAuxiliar.titulo}</h3>
      <hr/>
      <form onSubmit={this.searchReports}>
        <div className="row">
          <div className="col-md-6">
            <div className="form-group">
              <label>{this.locale.RelatoriosAuxiliaresFadiga.ProcurarRelatorioAuxiliar.formulario.DataInicial}:</label>
              <InputMask value={this.state.date_start} required maskChar={null} name="date_start" mask="99/99/9999" className="form-control" onChange={this.handleChange.bind(this, 'date_start')} placeholder="" />
            </div>
          </div>
          <div className="col-md-6">
            <div className="form-group">
              <label>{this.locale.RelatoriosAuxiliaresFadiga.ProcurarRelatorioAuxiliar.formulario.DataFinal}:</label>
              <InputMask value={this.state.date_finish} required maskChar={null} name="date_finish" mask="99/99/9999" className="form-control" onChange={this.handleChange.bind(this, 'date_finish')} placeholder="" />
            </div>
          </div>
        </div>
        <div>
          <button type="submit" className="btn btn-primary btn-block"><i className="fa fa-fw fa-search"></i> {this.locale.general.pesquisar}</button>
        </div>
      </form>
      <hr/>
      <h3 className="page-title">{this.locale.RelatoriosAuxiliaresFadiga.ProcurarRelatorioAuxiliar.tituloResultadosDeAutoavaliacoes}</h3>
      <hr/>
      <BootstrapTable data={this.state.data} pagination={true} striped={true} hover={true} exportCSV={true} options={{exportCSVText: 'Exportar CSV', noDataText: this.locale.RelatoriosAuxiliaresFadiga.ProcurarRelatorioAuxiliar.tabela.semParametroDeFadiga}} search={true} multiColumnSearch={true}  searchPlaceholder='Procurar'>

        <TableHeaderColumn isKey={true} dataField="id" dataAlign="center" type={'hidden'} width='60'>{this.locale.RelatoriosAuxiliaresFadiga.ProcurarRelatorioAuxiliar.tabela.ID}</TableHeaderColumn>

        <TableHeaderColumn sortFunc={ this.sortDates } dataField="created_at_str" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: 'Procurar'}} width='100'>{this.locale.RelatoriosAuxiliaresFadiga.ProcurarRelatorioAuxiliar.tabela.Data}</TableHeaderColumn>
        <TableHeaderColumn dataField="staff_name" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: 'Procurar'}} width='250'>{this.locale.RelatoriosAuxiliaresFadiga.ProcurarRelatorioAuxiliar.tabela.Colaborador}</TableHeaderColumn>
        <TableHeaderColumn dataField="first_question_risk_str" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: 'Procurar'}} width='130'>{this.locale.RelatoriosAuxiliaresFadiga.ProcurarRelatorioAuxiliar.tabela.Questao1}</TableHeaderColumn>
        <TableHeaderColumn dataField="second_question_risk_str" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: 'Procurar'}} width='130'>{this.locale.RelatoriosAuxiliaresFadiga.ProcurarRelatorioAuxiliar.tabela.Questao2}</TableHeaderColumn>
        <TableHeaderColumn dataField="third_question_risk_str" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: 'Procurar'}} width='130'>{this.locale.RelatoriosAuxiliaresFadiga.ProcurarRelatorioAuxiliar.tabela.Questao3}</TableHeaderColumn>
        <TableHeaderColumn dataField="fourth_question_risk_str" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: 'Procurar'}} width='130'>{this.locale.RelatoriosAuxiliaresFadiga.ProcurarRelatorioAuxiliar.tabela.Questao4}</TableHeaderColumn>
        <TableHeaderColumn dataField="result_str" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: 'Procurar'}} width='140'>{this.locale.RelatoriosAuxiliaresFadiga.ProcurarRelatorioAuxiliar.tabela.PontuacaoFinal}</TableHeaderColumn>


      </BootstrapTable>



    </div>
  </div>
</div>
    );
  }
}

export default SearchAuxiliaryReport;


// WEBPACK FOOTER //
// ./src/Components/FatigueAuxiliaryReports/SearchAuxiliaryReport.js